import type { BossFight } from '../../core/boss/boss-fight';
import { es, t, type StringKey } from '../../i18n/es';

export interface BossBarModel {
  visible: boolean;
  /** hp / maxHp, 0..1. */
  value: number;
  hp: number;
  maxHp: number;
  /** In-game nickname in upper case (key boss.<id>.name); a boss without one shows its id (TEST-BOSS). */
  name: string;
  /** Accessible value: "2 de 3". */
  valueText: string;
}

const nameKey = (id: string) => `boss.${id}.name`;
const isKey = (key: string): key is StringKey => key in es;

/**
 * The boss health bar of GDD §13.3 (issue #91), read from the fight of #89: shown while the boss fights in
 * the arena (its phases and transitions), hidden before it enters and once it retreats.
 */
export function bossBarModel(boss: Pick<BossFight, 'def' | 'hp' | 'status'> | null): BossBarModel {
  if (!boss) return { visible: false, value: 0, hp: 0, maxHp: 0, name: '', valueText: '' };
  const maxHp = boss.def.hp;
  const key = nameKey(boss.def.id);
  return {
    visible: boss.status === 'phase' || boss.status === 'transition',
    value: maxHp > 0 ? boss.hp / maxHp : 0,
    hp: boss.hp,
    maxHp,
    name: (isKey(key) ? t(key) : boss.def.id).toUpperCase(),
    valueText: t('ui.hud.boss.value', { hp: boss.hp, max: maxHp }),
  };
}
